export interface ConfigState {
    isMobile: boolean;
}

export const SET_IS_MOBILE = "SET_IS_MOBILE";

export type ConfigActionTypes = typeof SET_IS_MOBILE;
